import { render } from "./nrDetail.vue?vue&type=template&id=dbea77a2&scoped=true"
import script from "./nrDetail.vue?vue&type=script&lang=js"
export * from "./nrDetail.vue?vue&type=script&lang=js"

import "./nrDetail.vue?vue&type=style&index=0&id=dbea77a2&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbea77a2"]])

export default __exports__